<template>
  <div class="developing-wrapper">
    <!-- Soft gradient blobs -->
    <div class="blob blob-1"></div>
    <div class="blob blob-2"></div>
    <div class="blob blob-3"></div>

    <div class="content">
      <!-- Animated illustration -->
      <div class="illustration">
        <!-- Hammer tool -->
        <div class="hammer">
          <div class="hammer-head"></div>
          <div class="hammer-handle"></div>
        </div>
        <!-- Sparkles -->
        <div class="sparkle sparkle-1">✦</div>
        <div class="sparkle sparkle-2">✧</div>
        <div class="sparkle sparkle-3">✦</div>
        <div class="sparkle sparkle-4">⋆</div>
        <!-- Gear decoration -->
        <div class="mini-gear">⚙</div>
      </div>

      <!-- Text content -->
      <h1 class="main-title">页面建设中</h1>
      <p class="subtitle">程序员正在努力敲代码中...</p>
      <p class="description">这个功能很快就会上线，请稍后再来看看吧 ~</p>

      <!-- Action button -->
      <button class="back-btn" @click="goBack">
        <span class="btn-icon">←</span>
        <span class="btn-text">返回上一页</span>
      </button>

      <!-- Fun tip -->
      <div class="tip-box">
        <span class="tip-icon">💡</span>
        <span class="tip-text">小贴士：喝杯咖啡，待会儿再来看看</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Developing',
    methods: {
      goBack() {
        this.$router.go(-1)
      },
    },
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  // Theme color palette
  $primary: #1890ff;
  $primary-light: #69c0ff;
  $primary-lighter: #e6f7ff;
  $text-primary: #303133;
  $text-secondary: #606266;
  $text-muted: #909399;

  .developing-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 500px;
    width: 100%;
    background: linear-gradient(
      135deg,
      $primary-lighter 0%,
      #bae7ff 50%,
      $primary-lighter 100%
    );
    background-size: 400% 400%;
    animation: gradient-flow 15s ease infinite;
    overflow: hidden;
    border-radius: 12px;
  }

  @keyframes gradient-flow {
    0%,
    100% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
  }

  // Floating blobs
  .blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(60px);
    opacity: 0.5;
    animation: float-blob 20s ease-in-out infinite;
  }

  .blob-1 {
    width: 300px;
    height: 300px;
    background: linear-gradient(135deg, $primary-light, #91d5ff);
    top: -100px;
    right: -50px;
    animation-delay: 0s;
  }

  .blob-2 {
    width: 250px;
    height: 250px;
    background: linear-gradient(135deg, #69c0ff, #bae7ff);
    bottom: -80px;
    left: -50px;
    animation-delay: -7s;
  }

  .blob-3 {
    width: 200px;
    height: 200px;
    background: linear-gradient(135deg, #91d5ff, $primary);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation-delay: -14s;
  }

  @keyframes float-blob {
    0%,
    100% {
      transform: translate(0, 0) scale(1);
    }
    33% {
      transform: translate(30px, -30px) scale(1.1);
    }
    66% {
      transform: translate(-20px, 20px) scale(0.9);
    }
  }

  // Main content
  .content {
    position: relative;
    z-index: 1;
    text-align: center;
    padding: 50px 40px;
  }

  // Illustration
  .illustration {
    position: relative;
    width: 120px;
    height: 120px;
    margin: 0 auto 35px;
  }

  .hammer {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform-origin: bottom center;
    animation: hammer-swing 1s ease-in-out infinite;

    .hammer-head {
      width: 50px;
      height: 24px;
      background: linear-gradient(135deg, #64748b, #475569);
      border-radius: 4px;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: 4px;
        left: 4px;
        width: 42px;
        height: 6px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 2px;
      }
    }

    .hammer-handle {
      width: 12px;
      height: 50px;
      background: linear-gradient(90deg, #d4a574, #c4956a, #d4a574);
      border-radius: 0 0 6px 6px;
      margin: 0 auto;
    }
  }

  @keyframes hammer-swing {
    0%,
    100% {
      transform: translate(-50%, -50%) rotate(-15deg);
    }
    50% {
      transform: translate(-50%, -50%) rotate(15deg);
    }
  }

  // Sparkles
  .sparkle {
    position: absolute;
    color: $primary;
    font-size: 20px;
    animation: twinkle 1.5s ease-in-out infinite;
  }

  .sparkle-1 {
    top: 10px;
    left: 20px;
    animation-delay: 0s;
  }
  .sparkle-2 {
    top: 30px;
    right: 15px;
    animation-delay: 0.3s;
    font-size: 16px;
  }
  .sparkle-3 {
    bottom: 20px;
    left: 10px;
    animation-delay: 0.6s;
  }
  .sparkle-4 {
    bottom: 40px;
    right: 25px;
    animation-delay: 0.9s;
    font-size: 14px;
  }

  @keyframes twinkle {
    0%,
    100% {
      opacity: 0;
      transform: scale(0.5);
    }
    50% {
      opacity: 1;
      transform: scale(1.2);
    }
  }

  .mini-gear {
    position: absolute;
    bottom: 5px;
    right: 0;
    font-size: 24px;
    color: $primary;
    animation: spin-gear 4s linear infinite;
  }

  @keyframes spin-gear {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  // Typography
  .main-title {
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
    font-size: 36px;
    font-weight: 600;
    color: $text-primary;
    margin: 0 0 12px;
    letter-spacing: 2px;
  }

  .subtitle {
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
    font-size: 18px;
    font-weight: 400;
    color: $text-secondary;
    margin: 0 0 8px;
  }

  .description {
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
    font-size: 15px;
    font-weight: 300;
    color: $text-muted;
    margin: 0 0 35px;
  }

  // Button
  .back-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 28px;
    background: $primary;
    border: none;
    border-radius: 50px;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
    font-size: 15px;
    font-weight: 500;
    color: #fff;
    cursor: pointer;
    box-shadow: 0 4px 20px rgba(24, 144, 255, 0.3);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 30px rgba(24, 144, 255, 0.4);
      background: #40a9ff;
    }

    &:active {
      transform: translateY(0);
    }

    .btn-icon {
      font-size: 18px;
    }
  }

  // Tip box
  .tip-box {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin-top: 30px;
    padding: 10px 20px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 30px;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
    font-size: 13px;
    color: $text-secondary;
    backdrop-filter: blur(10px);

    .tip-icon {
      font-size: 16px;
    }
  }
</style>
